import DtoDashboardSite from './DtoDashboardSite'

export default class DtoPollutedSoil extends DtoDashboardSite {
	constructor(obj) {
		super(obj)
		this.headers = ['code', 'name', 'city']
	}
}



// WEBPACK FOOTER //
// ./src/dashboard/dto/DtoIndustrialSite.js